export default class StickyController {
    constructor(stickyEl) {
        this.defaults = {
            //
            activeClass: "is-active",

            //CSS state classes
            scrolled: "has-scrolled",
            slideUp: "slide-up",
        };

        this.stickyElClass = stickyEl;

        //navigation controller config
        this.scrolling = false;
        this.scrollElemeentOffset = 20;
        this.previousTop = 0;
        this.scrollDelta = 0;
        this.scrollOffset = 0;

        if (this.stickyEl) {
            this.scrollController();
        }
    }

    //region getters
    /**
     *
     * @returns {Element}
     */
    get stickyEl() {
        return document.querySelector(this.stickyElClass);
    }

    //endregion

    //region methods
    scrollController() {
        document.addEventListener("scroll", () => {
            if (!this.scrolling) {
                this.scrolling = true;

                if (!window.requestAnimationFrame) {
                    setTimeout(this.checkScroll(), 250);
                } else {
                    requestAnimationFrame(() => this.checkScroll());
                }
            }
        });
    }

    /**
     *
     */
    checkScroll() {
        let currentTop = window.pageYOffset | document.body.scrollTop;

        if (this.stickyEl) {
            this.activateElement(currentTop);
        }

        this.previousTop = currentTop;
        this.scrolling = false;
    }

    activateElement(currentTop) {
        if (currentTop > this.scrollElemeentOffset) {
            this.stickyEl.classList.add(this.defaults.scrolled);
        } else {
            this.stickyEl.classList.remove(this.defaults.scrolled);
        }

        let navOffsetTop = window.innerHeight / 2;

        if (this.previousTop >= currentTop) {
            //SCROLLING UP
            if (currentTop < navOffsetTop) {
                // secondary nav is not fixed
                this.stickyEl.classList.remove(
                    this.defaults.slideUp,
                );
            } else if (this.previousTop - currentTop > this.scrollDelta) {
                // secondary nav is fixed

                this.stickyEl.classList.remove(
                    this.defaults.slideUp,
                );
            }
        } else {
            // SCROLLING DOWN
            if (currentTop > navOffsetTop + this.scrollOffset) {
                // hide primary nav
                this.stickyEl.classList.add(
                    this.defaults.slideUp,
                );
            } else if (currentTop > navOffsetTop) {
                // once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset
                this.stickyEl.classList.remove(
                    this.defaults.slideUp,
                );
            }
        }
    }

    //endregion
}
